export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Fresh Produce & Pantry",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/airasia-farm-sabah.jpg",
      title: "airasia farm penang",
      subtitle: "Selling frozen meat, seafood, chicken, eggs, fruits and vegetables",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/airasia-farm-penang"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/sin-soo-hup.jpg",
      title: "SIN SOO HUP",
      subtitle: "Widest range of fresh fruits and vegetables",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-sin-soo-hup"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/localpedia.jpg",
      title: "Localpedia.pg",
      subtitle: "Ambarella and nutmeg pickles at RM13.70 storewide",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-localpedia-pg"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/little-sifu.jpg",
      title: "Penang Little Sifu",
      subtitle: "Penang Asam Laksa from RM6.20",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-penang-little-sifu"
    }
  ],
}
